<template>
  <narrow-container>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('ACTIVATE.HEADER') }}
    </h1>
    <h1 class="headline-sub text--center">
      {{ this.$i18n.t('ACTIVATE.SUBHEADER') }}
    </h1>
    <p>{{ this.$i18n.t('ACTIVATE.P1') }}</p>
    <p>
      <strong>{{ this.$i18n.t('ACTIVATE.NOTE') }}</strong>
      {{ this.$i18n.t('ACTIVATE.P2') }}
    </p>
    <validated-input-box
      id="loginFieldActivation"
      ref="loginField"
      :validation-reg-exp="numberRegex"
      :validation-error-message="$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_ERROR')"
      :label="this.$i18n.t('ACTIVATE.LOGIN_NUMBER')"
      placeholder="6789123456789"
      name="loginField"
    />
    <validated-input-box
      id="codeField"
      ref="codeField"
      :validation-reg-exp="pukRegex"
      :validation-error-message="$i18n.t('ACTIVATE.CODE_ERROR')"
      :label="this.$i18n.t('ACTIVATE.ACTIVATION_CODE')"
      placeholder="12345678"
      name="codeField"
    />
    <submit-button
      id="activationSubmitButton"
      :label="this.$i18n.t('ACTIVATE.ACTIVATE')"
      :on-click="submitForm"
      :disabled="!frcResponse"
    />
    <friendly-captcha-field
      ref="captcha"
      v-model="frcResponse"
    />
    <activation-accordions />
  </narrow-container>
</template>

<script>
import Regex from '@/constants/regex.json';
import ActivationAccordions from '@/views/activation/ActivationAccordions';
import FriendlyCaptchaField from '@/components/common/FriendlyCaptchaField.vue';

const VALIDATION_ERROR = 1;
const TEMPORARILY_LOCKED =2;
const PUK_INCORRECT = 3;
const ACTIVATION_NOT_POSSIBLE = 4;
const SIM_INACTIVE = 5;
const OTHER_ERROR = 9999;

export default {
  name: 'Activation',
  components: { ActivationAccordions, FriendlyCaptchaField },
  data: function() {
    return {
      inProgress: false,
      frcResponse: null,
      VerifyActivationRequest: null,
    };
  },
  computed: {
    numberRegex() {
      return Regex.NUMBER;
    },
    pukRegex() {
      return Regex.PUK;
    },
  },
  methods: {
    isFormValid: function() {
      const isValid = this.$refs.loginField.isValidBeforeSubmit()
        && this.$refs.codeField.isValidBeforeSubmit();
      return isValid;
    },
    submitForm: function() {
      if (this.isFormValid() && !this.inProgress && this.$refs.captcha.isValid()) {
        this.inProgress = true;
        this.VerifyActivationRequest = {
          msisdn: this.$refs.loginField.getFieldValue(),
          puk: this.$refs.codeField.getFieldValue(),
        };
        this.$http.post('api/protected/dreitvkarte/verifyActivation', this.VerifyActivationRequest, {
          headers: {
            'friendly-captcha-version': 'v2',
            'friendly-captcha-response': this.frcResponse
          }
        })
          .then( (response) => {
            this.processSuccessfulCallResponse(response);
          })
          .catch(callData => {
            this.processErrorCallResponse(callData);
            this.$refs.captcha.reset();
          })
          .finally(() => {
            this.inProgress = false;
          })
      }
    },
    processSuccessfulCallResponse: function(response) {
      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Activation',label: 'Success', value: 0, noninteraction: false });
      this.$store.commit("setActivationToken", this.VerifyActivationRequest);
      this.$store.commit("setVoucherAllowed", response.data.voucherAllowed)
      this.$router.push({name: 'kuzoRegistration'});
    },

    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Activation',label: 'Error - no data', value: 0, noninteraction: false });
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case VALIDATION_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.VALIDATION_ERROR'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Activation',label: 'Error - validation error', value: 0, noninteraction: false });
          break;
        case TEMPORARILY_LOCKED:
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.TEMPORARILY_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Activation',label: 'Error - temporarily locked', value: 0, noninteraction: false });
          break;
        case PUK_INCORRECT:
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.PUK_INCORRECT'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Activation',label: 'Error - PUK incorrect', value: 0, noninteraction: false });
          break;
        case ACTIVATION_NOT_POSSIBLE:
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.ACTIVATION_NOT_POSSIBLE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Activation',label: 'Error - activation not possible', value: 0, noninteraction: false });
          break;
        case SIM_INACTIVE:
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.SIM_INACTIVE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Activation',label: 'Error - USIM inactive', value: 0, noninteraction: false });
          break;
        case OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Activation',label: 'Error - technical issue', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Activation',label: 'Error - '+responseCode, value: 0, noninteraction: false });
      }
    },
  },
};
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
